import { cn } from '../../utils/cn';

export function Skeleton({ className, ...rest }) {
  return (
    <div
      {...rest}
      className={cn('animate-pulse rounded-md bg-bg-subtle', className)}
      aria-hidden
    />
  );
}